//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scrolingGallery } from '~/utils/utils';
import LinkedCompSliderItem from "~/components/compilations/LinkedCompSliderItem"
export default {
  components: {
    LinkedCompSliderItem
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      x: 0
    }
  },
  computed: {
    eventsListeners() {
      return {
        ...this.$listeners,
        ...scrolingGallery(this, 'LinkedComp_Slider')
      }
    }
  },
  methods: {
    handleLink(e) {
      if (!this.movingActive) {
        e.preventDefault()
        e.stopPropagation()
      }
    }
  },
  chimera: {}
}
